import { isPlatformBrowser, NgClass, NgFor, NgIf, SlicePipe } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnInit, Output, PLATFORM_ID } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FuseCardComponent } from '@fuse/components/card';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { AbstractControl, FormBuilder, FormGroup, ReactiveFormsModule, ValidatorFn, Validators } from '@angular/forms';
import { FuseAlertComponent, FuseAlertType } from '@fuse/components/alert';
import { SharedMethodsModule } from 'app/core/shared-services/shared-methods.module';
import { MatIconModule } from '@angular/material/icon';
import { IBankList, ICustomer, ICustomerAccount, ILead} from 'app/core/shared-services/shared-interface.types';
import { SharedServiceService } from 'app/core/shared-services/shared-service.service';
import Swal from 'sweetalert2';
import { ActivatedRoute, Router } from '@angular/router';
import { GtmService } from 'app/core/shared-services/gtm.service';
import { WebStorage } from 'app/core/shared-services/web.storage';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
@Component({
  standalone: true,
  selector: 'app-payment-methods',
  templateUrl: './payment-methods.component.html',
  imports: [MatIconModule, FuseAlertComponent, FuseCardComponent, NgClass, NgIf, NgFor, MatButtonModule, MatDialogModule, MatInputModule, MatFormFieldModule,
     MatSelectModule, SlicePipe, MatButtonModule, MatProgressSpinnerModule, MatCheckboxModule, MatProgressSpinnerModule, ReactiveFormsModule, SharedMethodsModule]
})


export class PaymentMethodComponent implements OnInit {
  
  @Input() dealerCode: string;
  @Input() currentPaymentMethod: IBankList;
  @Input() validPayment: boolean;
  @Input() checkoutProcessView: boolean = false;
  @Input() dashboardProcessView: boolean = false;
  @Output() closeModal = new EventEmitter();

  selectedPaymentMethod: string = 'BankAccount';

  public customerDebitOrderDetails: any;
  public addPaymentMethodResponse: any;
  public updateDebitOrderDateResponse: any;
  public bankList: any;
  public bankAccountList: any;

  public leadResult: any;
  public lead: ILead;

  public addPaymentForm: FormGroup;
  public debitOrderForm: FormGroup;
  public updateDebitOrderForm: FormGroup;

  public showAlert: boolean = false;
  public bankIsValidated: boolean = true;
  public loading: boolean = false;
  public errorMessage: string;
  public alert: { type: FuseAlertType; message: string };
  public collectionRuns: any; 
  public paymentDetails: IBankList;
  public customerDetails: ICustomerAccount
  isDealerJourney: boolean;
  public customerCollectionRun: any;

  public btnLoading: boolean = false;

  private referrer: string;

  /**
     * Constructor
     */

  constructor(
    private _sharedMethods: SharedMethodsModule,
    private _sharedService: SharedServiceService,
    private dialog: MatDialog,
    private _fb: FormBuilder,
    private router: Router,
    private _gtmService: GtmService,
    private _webStorage: WebStorage,
    private activatedRouter: ActivatedRoute,

    @Inject(PLATFORM_ID) private platformId: any

  ){
  }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */

    async ngOnInit() {

      this.isDealerJourney = this.activatedRouter.snapshot.url.some(segment => segment.path === 'pre-orders');

      this.leadResult = await this._sharedMethods.getLeadById(this._webStorage.CartInfo.getValue()?.LeadEntityID);
      if (this.leadResult.success) {
        this.lead = this.leadResult.result;
      }

      this.customerDetails = (await this._sharedMethods.getCustomerAccount()).result;

      this.getDebitOrderCollectionRuns();
      this.getPaymentMethod();
 
      this.addPaymentForm = this._fb.group({
        bank: ['', Validators.required],
        bankType: ['', Validators.required],
        accountNumber: ['', Validators.required],
        accountHolder: ['', Validators.required],
        collectionRuns: ['', Validators.required],
      });

      this.debitOrderForm = this._fb.group({
        collectionRuns: ['', Validators.required],
      });

      this.customerDetails = (await this._sharedMethods.getCustomerAccount()).result;
      this.getPaymentMethod();
      await this.getDebitOrderCollectionRuns();
    }

    ngOnChanges() {
      this.validPayment = this.currentPaymentMethod !== undefined ? true : false;  
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public Methods
    // 
    public async addPaymentMethod(templateRef: any) {
      this.btnLoading = true;
      this.getBanks();
      this.getBankAccountTypes();
      this.getPaymentMethod();

      this.customerDetails = (await this._sharedMethods.getCustomerAccount()).result;
      this.getDebitOrderCollectionRuns().then(() => {
        this.btnLoading = false;
      });

      this.dialog.open(templateRef, {
        width: '900px',
        backdropClass: 'blurModalBackground'
      });
    }

    public changeDebitDate(templateRef: any) {
      this.getDebitOrderCollectionRuns()

      this.dialog.open(templateRef, {
        width: '700px',
        backdropClass: 'blurModalBackground'
      }).afterClosed().subscribe((result: any) => {
        if(result){
          // this.getCustomerDebitOrderDetails();
        }
      });
    }



    public async submitPaymentMethod() {

    this.loading = true;

      
    if (isPlatformBrowser(this.platformId)) {
      if(localStorage.getItem('currentURL')) {
        if(localStorage.getItem('currentURL') == window.location.href) {
          //this.referrer = window.location.href
        } else {
          this.referrer = localStorage.getItem('currentURL')
          localStorage.setItem('currentURL', window.location.href);
          localStorage.setItem('previousURL', this.referrer);
        }
      } else {
        localStorage.setItem('currentURL', window.location.href);
      }
    }
      const data = {
        BankAccountBranchCode: this.addPaymentForm?.value?.bank.DefaultCode,
        BankAccountName: this.addPaymentForm?.value?.accountHolder,
        BankAccountNumber: this.addPaymentForm?.value?.accountNumber,
        BankAccountType: this.addPaymentForm?.value?.bankType,
        BankName: this.addPaymentForm?.value?.bank.BankName,
        IsDefault: true,
        PaymentMethod: 'BankAccount',
        PaymentType: 'DebitOrder' 
      }

      const route = window.location.href;
      const path = this.router.url;

      if (this.isDealerJourney) {
        this._gtmService.pushEvent({ 
          event: 'add_payment_method_dealer',
          page_url: route,
          page_path: path,
          page_referrer: this.referrer ? this.referrer : route,
          page_title: 'pre-orders_page',
          dealer_code: this.dealerCode
        });
      } else {
        this._gtmService.pushEvent({ 
          event: 'add_payment_method',
          page_url: route,
          page_path: path,
          page_referrer: this.referrer ? this.referrer : route
        });
      }



      this.addPaymentMethodResponse = (await this._sharedMethods.addPaymentMethods(data));
      if(this.addPaymentMethodResponse.success || this.addPaymentMethodResponse.result?.IsValidated) {
        this.loading = false;
        this.bankIsValidated = true;
        this.closeModal.emit();
        this.dialog.closeAll();
        this.getPaymentMethod();
        this.updateDebitOrderDate()


        
        // const route = window.location.href;
        // const path = this.router.url;
        // if (this.isDealerJourney) {
        //   this._gtmService.pushEvent({ 
        //     event: 'add_payment_method_dealer',
        //     page_url: route,
        //     page_path: path,
        //     page_referrer: this.referrer ? this.referrer : route,
        //     page_title: 'pre-orders_page',
        //     dealer_code: this.dealerCode
        //   });
        // } else {
        //   this._gtmService.pushEvent({ 
        //     event: 'add_payment_method_online',
        //     page_url: route,
        //     page_path: path,
        //     page_referrer: this.referrer ? this.referrer : route
        //   });
        // }


      } else {
        this.errorMessage = this.addPaymentMethodResponse.result?.ValidationStatusMessage ? this.addPaymentMethodResponse.result.ValidationStatusMessage : this.addPaymentMethodResponse.error.error.Message;
        this.bankIsValidated = false;
        this.loading = false;
      }

    }


    public async changeDebitOrderDate() {
      this.customerDetails.DebitOrderCollectionRunID = this.debitOrderForm?.value?.collectionRuns?.ID;
      this.addPaymentMethodResponse = await this._sharedMethods.changeDebitOrderDate(this.customerDetails);
      if(this.addPaymentMethodResponse?.success){
        Swal.fire({
          toast: true,
          timer: 3000,
          position: 'bottom-end', 
          title: 'Date Updated!',
          icon: 'success',
          showCancelButton: false,
          showConfirmButton: false,
          customClass: {
            title:'text-xl',
            htmlContainer: 'text-lg',
            confirmButton: 'custom-button text-md',
          }
        }).then(()=>{
          this.dialog.closeAll();
        });
      }else{
        Swal.fire({
          title: 'Date Updated Failed!',
          text: this.addPaymentMethodResponse?.error?.error?.Message,
          icon: 'error',
          showCancelButton: false,
          confirmButtonText: 'OKAY',
          showConfirmButton: true,
          customClass: {
            title:'text-xl',
            htmlContainer: 'text-lg',
            confirmButton: 'custom-button text-md',
          }
        });
      }
    }

    // Update debit order date
    public async updateDebitOrderDate() {

      const formData = this.addPaymentForm?.value

      //update debit order date details on customer account
      this.customerDetails.DebitOrderCollectionRunID = formData?.collectionRuns?.ID;
      this.customerDetails.DebitOrderCollectionRunName = formData?.collectionRuns?.Description;
      this.updateDebitOrderDateResponse = await this._sharedMethods.updateCustomerAccount(this.customerDetails);

      if(this.updateDebitOrderDateResponse?.success){
          Swal.fire({
            toast: true,
            timer: 3000,
            position: 'bottom-end', 
            title: 'Debit Order Date Updated!',
            icon: 'success',
            showCancelButton: false,
            showConfirmButton: false,
            customClass: {
              title:'text-md',
              htmlContainer: 'text-md',
              confirmButton: 'custom-button text-md',
            }
          });
      }else{
          Swal.fire({
            toast: true,
            timer: 5000,
            position: 'bottom-end', 
            title: 'Date Updated Failed!',
            text: this.updateDebitOrderDateResponse?.error?.error?.Message,
            icon: 'error',
            showCancelButton: false,
            showConfirmButton: false,
            customClass: {
              title:'text-md',
              htmlContainer: 'text-md',
              confirmButton: 'custom-button text-md',
            }
          });
        }
    }

    public closeDialog() {
      this.closeModal.emit();
      this.dialog.closeAll();
      this.getPaymentMethod();
    }

    public changePaymentMethod(method: string) {
      this.selectedPaymentMethod = method;
    }

    /* -------------------------------------------------------------------------- */
    /*                      Submit Credit Card Payment Method                     */
    /* -------------------------------------------------------------------------- */
    public async submitCreditMethod() {

      const payNowData = {
        isPendingPayment: true,
        entityAccountID: this.customerDetails?.EntityAccountEntityID,
        accountReceiptPaymentType: 'CreditCard',
        pendingAmount: 1,
        isForCardTokenisation: true,
        debitOrderCollectionRunID: this.addPaymentForm?.value?.collectionRuns?.ID ?? null
      }

      const payNowResult = await this._sharedMethods.payNow(payNowData);
      
      if (payNowResult?.success) {
        const actionLink = payNowResult.result[0].PaymentLink;
        window.open(actionLink, '_blank');
      } else {
        Swal.fire({
          title: 'Failed Payment!',
          icon: 'error',
          text: payNowResult.error.error.Message,
          showCancelButton: false,
          confirmButtonText: 'OKAY',
          customClass: {
            htmlContainer: 'text-lg',
            confirmButton: 'custom-button text-md',
          }
        });
      }
  
    }

    

    // -----------------------------------------------------------------------------------------------------

    // @ Private Methods
    // 
    private async getBanks() {
      this.bankList = (await this._sharedMethods.getBankLists()).result;
    }

    private async getBankAccountTypes() {
      this.bankAccountList = (await this._sharedMethods.getBankAccountTypeList()).result;
    }

    private async getDebitOrderCollectionRuns() {
      try { this.collectionRuns = (await this._sharedMethods.getDebitOrderCollectionRuns()).result;
      } catch (err) {
        console.error(err);
      }
      if (this.collectionRuns) {
        this.customerCollectionRun = this.collectionRuns.find((element) => element.ID == this.customerDetails?.DebitOrderCollectionRunID);
        this.patchDebitOrderDateForm();
      }
    }

    private async getPaymentMethod(){
      let currentPaymentMethod: any = await this._sharedMethods.getPaymentMethods();
      this.currentPaymentMethod  = currentPaymentMethod?.result?.find((x: any) => (x.IsDefault === true && x.IsValidated));
      this.validPayment = this.currentPaymentMethod !== undefined ? true : false;  
    }

    private patchDebitOrderDateForm() {
        this.debitOrderForm?.patchValue({
          collectionRuns: this.customerCollectionRun
        });
    }

}